import * as R from 'ramda';
import { FC, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Table } from 'reactstrap';
import { withBorder } from '../../../reactutils/withBorder';
import { withLogin } from '../../../reactutils/withLogin';
import { withMenu } from '../../../reactutils/withMenu';
import { TabbedContent } from '../../../reactutils/withTabbedScreen';
import { withTitle } from '../../../reactutils/withTitle';
import { UseCaseAccounting } from '../../../services/account';
import { formatNumber } from '../../../utils';
import { LoadingIndicatorSpinner } from '../../common/LoadingIndicatorSpinner';
import { MenuSysAdmin } from '../../MenuSysAdmin';
import { getSystemConfig, ServerType } from '../../System/systemConfig';
import { usePathSegment } from '../CacheStatisticsComponent';
import { sysadminClearUseCaseLogs, sysadminLoadUseCaseLogs } from './actions';
import { selectorUseCaseLogEntities } from './selectors';

const UseCaseLogs: FC<{}> = (props) => {
    const dispatch = useDispatch();

    const [server] = usePathSegment(3) as ServerType[];
    const entities = useSelector(selectorUseCaseLogEntities(server));

    useEffect(() => {
        if (server) {
            dispatch(sysadminLoadUseCaseLogs(server));
        }
    }, [dispatch, server]);

    const renderUseCaseLog = (ucl: UseCaseAccounting) => {
        return (
            <tr key={ucl.name}>
                <td>{ucl.name}</td>
                <td className="text-right">{ucl.count}</td>
                <td className="text-right">{formatNumber(ucl.duration, 0)}</td>
                <td className="text-right">{formatNumber(ucl.avgDuration, 1)}</td>
                <td className="text-right">{formatNumber(ucl.minDuration, 0)}</td>
                <td className="text-right">{formatNumber(ucl.maxDuration, 0)}</td>
            </tr>
        );
    };
    return (
        <>
            <TabbedContent
                activeTab={server}
                tabLinks={sysAdminUseCaseLogPath}
                tabNames={Object.keys(getSystemConfig().serverUrls)}
            />
            <Button
                color="secondary"
                outline={false}
                className="m-2"
                onClick={() => dispatch(sysadminLoadUseCaseLogs(server))}
            >
                Reload
            </Button>
            <Button
                color="danger"
                outline={false}
                className="m-2"
                onClick={() => dispatch(sysadminClearUseCaseLogs(server))}
            >
                Clear
            </Button>
            <Table>
                <thead>
                    <tr>
                        <th>Use Case</th>
                        <th>Count</th>
                        <th>Duration</th>
                        <th>Avg (ms)</th>
                        <th>Min (ms)</th>
                        <th>Max (ms)</th>
                    </tr>
                </thead>
                <tbody>
                    {entities && entities.map((e) => renderUseCaseLog(e))}
                    {!entities && (
                        <tr>
                            <td>
                                <LoadingIndicatorSpinner />
                            </td>
                        </tr>
                    )}
                </tbody>
            </Table>
        </>
    );
};

export const sysAdminUseCaseLogPath = (serverName: string) => `/sys/ucl/${serverName}`;

export const UseCaseLogScreen = R.compose(
    withMenu(<MenuSysAdmin />),
    withBorder(),
    withTitle('Use Case Logs'),
    withLogin()
)(UseCaseLogs);
